// 3rd party imports
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import store, { RootState } from 'store';
import { data } from 'jquery';

// Local imports
import Pills from '../../../../Common/Components/Pills';
import TemplateCard from './TemplateCard';
import TemplateSearch from './TemplateSearch';
import { getTemplates } from '../../actions';
import { Link } from 'react-router-dom';
import TemplatesHeader from './TemplatesHeader';
import { TEMPLATES_TYPE } from './constants';
import { ITemplateItem } from './../../../interfaces';
import InfiniteLoader from 'modules/Common/Components/InfiniteLoader';
import ButtonRightIconGreen from 'modules/Common/Components/ButtonRightIconGreen';
import TemplatesPlaceholder from './TemplatesPlaceholder';
import PreviewFull from 'modules/Design/Shared/PreviewFull';
import { ASSET_TYPE } from '../../../../../constants/index';
import Cross from '../../../../../assets/img/icons/cross.svg';
import DoneGreen from '../../../../../assets/img/icons/tick-white.svg';

// style imports
import styled from 'styled-components';
import { DESIGN_PREVIEW } from 'constants/actionTypes';
import { ADHOC } from 'constants/types';

type Props = {
  isToggle?: boolean;
  setSelectedTemplateId: any;
  setSelectedTemplateImage: any;
  setSelectedTemplateName: any;
  handleAdhocNameInput: any;
  selectedTemplateId: any;
  setToggleDisabled: any;
};

interface ITemplateLoad {
  my_templates_tab: boolean;
  shared_templates_tab: boolean;
  featured_tab: boolean;
}

// Constants for pagination
const DEFAULT_PAGE_LIMIT = 30;

const TemplateAsider: React.FC<Props> = ({
  isToggle,
  setSelectedTemplateId,
  setSelectedTemplateName,
  setSelectedTemplateImage,
  handleAdhocNameInput,
  selectedTemplateId,
  setToggleDisabled,
}) => {
  const featured: any = useSelector((state: RootState) => state.adHocTemplates.featured);
  const my_templates: any = useSelector((state: RootState) => state.adHocTemplates.my_templates);
  const shared: any = useSelector((state: RootState) => state.adHocTemplates.shared);
  const loading: any = useSelector((state: RootState) => state.adHocTemplates.loading);
  const templatesSearchSuccess: boolean = useSelector((state: RootState) => state.adHocTemplates.success); // For Alpha case in search
  const templatesSearchErrorMessage: string = useSelector((state: RootState) => state.adHocTemplates.message); // For Alpha case in search
  const [templateType, setTemplateType] = useState(TEMPLATES_TYPE.FEATURED);
  const [featuredTemplatesList, setFeaturedTemplatesList] = useState(featured.templates);
  const [myTemplatesList, setMyTemplatesList] = useState(my_templates.templates);
  const [sharedTemplatesList, setSharedTemplatesList] = useState(shared.templates);
  const [searchValue, setSearchValue] = useState('');
  const [isSearched, setIsSearched] = useState(false);
  const [togglePreview, setTogglePreview] = useState(false);
  const [templateIdPreview, setTemplateIdPreview] = useState(0);
  const [toggleFooter, setToggleFooter] = useState('');
  const [firstTimeLoad, setFirstTimeLoad] = useState(true);
  const DEFAULT_TEMPLATE_LOAD = {
    my_templates_tab: false,
    shared_templates_tab: false,
    featured_tab: false,
  };
  //State to prevent multiple API call on switching tabs between shared,feature, my templates
  const [templatesLoaded, setTemplatesLoaded] = useState<ITemplateLoad>(DEFAULT_TEMPLATE_LOAD);

  const selectTemplate = (id: number, name: string, image: string) => {
    // When user clicks on any template, set template properties
    setSelectedTemplateId(id);
    setSelectedTemplateName(name);
    setSelectedTemplateImage(image);
    if (name !== '') {
      setToggleFooter('show-footer');
    } else {
      setToggleFooter('');
    }
    handleAdhocNameInput(id, 'id');
  };

  const renderTemplatesList = (reset?: boolean) => {
    if (templateType === TEMPLATES_TYPE.FEATURED) {
      if (reset) {
        setFeaturedTemplatesList({});
      } else {
        setFeaturedTemplatesList(featured.templates);
      }
    }
    if (templateType === TEMPLATES_TYPE.SHARED) {
      if (reset) {
        setSharedTemplatesList({});
      } else {
        setSharedTemplatesList(shared.templates);
      }
    }
    if (templateType === TEMPLATES_TYPE.MY_TEMPLATES) {
      if (reset) {
        setMyTemplatesList({});
      } else {
        setMyTemplatesList(my_templates.templates);
      }
    }
  };

  const getRespectiveTemplates = () => {
    if (templateType === TEMPLATES_TYPE.MY_TEMPLATES && !templatesLoaded.my_templates_tab) {
      store.dispatch({
        type: ADHOC.RESET_PAGE_NUMBER,
        templateType: TEMPLATES_TYPE.MY_TEMPLATES,
      });
      getTemplates(
        {
          limit: DEFAULT_PAGE_LIMIT,
          offset: 0,
          templateType: TEMPLATES_TYPE.MY_TEMPLATES,
          searchValue: '',
          renderTemplatesList: renderTemplatesList,
        },
        renderTemplatesList,
      );
    } else if (templateType === TEMPLATES_TYPE.SHARED && !templatesLoaded.shared_templates_tab) {
      store.dispatch({
        type: ADHOC.RESET_PAGE_NUMBER,
        templateType: TEMPLATES_TYPE.SHARED,
      });
      getTemplates(
        {
          limit: DEFAULT_PAGE_LIMIT,
          offset: 0,
          templateType: TEMPLATES_TYPE.SHARED,
          searchValue: '',
          renderTemplatesList: renderTemplatesList,
        },
        renderTemplatesList,
      );
    } else if (templateType === TEMPLATES_TYPE.FEATURED && !templatesLoaded.featured_tab) {
      store.dispatch({
        type: ADHOC.RESET_PAGE_NUMBER,
        templateType: TEMPLATES_TYPE.FEATURED,
      });
      getTemplates(
        {
          limit: DEFAULT_PAGE_LIMIT,
          offset: 0,
          templateType: TEMPLATES_TYPE.FEATURED,
          searchValue: '',
          renderTemplatesList: renderTemplatesList,
        },
        renderTemplatesList,
      );
    }
    setTemplatesLoaded((prev: ITemplateLoad) => ({ ...prev, [templateType]: true }));
  };

  const searchTemplates = (e: any) => {
    // Search templates
    if (e.target !== undefined) {
      setSearchValue(e.target.value);
      e.stopPropagation();
      if (e.which === 13) {
        if (e.target.value.trim().length > 0) {
          store.dispatch({
            type: ADHOC.RESET_PAGE_NUMBER,
            templateType: templateType,
          });
          getTemplates({ limit: DEFAULT_PAGE_LIMIT, offset: 0, templateType: templateType, searchValue: searchValue }, renderTemplatesList);
          setIsSearched(true);
          setSearchValue(e.target.value);
        }
      } else {
        if (searchValue !== '' && isSearched && e.target.value == '') {
          renderTemplatesList(true);
          store.dispatch({
            type: ADHOC.RESET_PAGE_NUMBER,
            templateType: templateType,
          });
          setIsSearched(false);
          getTemplates({ limit: DEFAULT_PAGE_LIMIT, offset: 0, templateType: templateType, searchValue: '' }, renderTemplatesList);
        }
      }
    } else {
      if (searchValue.trim().length > 0) {
        store.dispatch({
          type: ADHOC.RESET_PAGE_NUMBER,
          templateType: templateType,
        });
        getTemplates({ limit: DEFAULT_PAGE_LIMIT, offset: 0, templateType: templateType, searchValue: searchValue }, renderTemplatesList);
        setIsSearched(true);
      }
    }
  };
  const cleanSearchField = () => {
    // Clear search field and render all templates
    setSearchValue('');
    setIsSearched(false);
    // call API when user already search something and then click on clear button to clear search field and render all templates
    if (isSearched) {
      store.dispatch({
        type: ADHOC.RESET_PAGE_NUMBER,
        templateType: templateType,
      });
      getTemplates({ limit: DEFAULT_PAGE_LIMIT, offset: 0, templateType: templateType, searchValue: '' }, renderTemplatesList);
      store.dispatch({
        type: ADHOC.ERROR_SEARCH_TERM,
        payload: { message: '', success: true },
      });
    }
  };

  const clearAllSelection = () => {
    // Remove selected class
    document.querySelectorAll('.template-card').forEach(function (item) {
      if (item.classList.contains('selected')) {
        item.classList.remove('selected');
      }
    });
    setSelectedTemplateId(0);
    setSelectedTemplateName('');
    setSelectedTemplateImage('');
    handleAdhocNameInput();
    setToggleDisabled('disabled');
  };

  const showPreview = (id: number) => {
    // Show popup preview
    store.dispatch({
      type: DESIGN_PREVIEW.LOAD_SUCCESS,
      preview_html: '',
      preview_text: '',
      default_preview_text: '',
    });
    store.dispatch({
      type: DESIGN_PREVIEW.ADHOC_RESET,
    });
    setTogglePreview(true);
    setTemplateIdPreview(id);
  };
  const getPagination = (searchValue: string) => {
    let offset = 0;
    if (templateType === TEMPLATES_TYPE.FEATURED) {
      offset = featured.page > 0 ? featuredTemplatesList.length : 0;
    } else if (templateType === TEMPLATES_TYPE.SHARED) {
      offset = shared.page > 0 ? sharedTemplatesList.length : 0;
    } else if (templateType === TEMPLATES_TYPE.MY_TEMPLATES) {
      offset = my_templates.page > 0 ? myTemplatesList.length : 0;
    }

    return {
      limit: DEFAULT_PAGE_LIMIT,
      offset: offset,
      templateType: templateType,
      searchValue: searchValue,
      renderTemplatesList: renderTemplatesList,
    };
  };

  useEffect(() => {
    setTemplateType(TEMPLATES_TYPE.FEATURED);

    if (templateType === TEMPLATES_TYPE.FEATURED) {
      if (featuredTemplatesList.length === 0 && !loading) {
        getTemplates(getPagination(searchValue), renderTemplatesList);
      }
    } else if (templateType === TEMPLATES_TYPE.SHARED) {
      if (sharedTemplatesList.length === 0 && !loading) {
        getTemplates(getPagination(searchValue), renderTemplatesList);
      }
    } else if (templateType === TEMPLATES_TYPE.MY_TEMPLATES) {
      if (myTemplatesList.length === 0 && !loading) {
        getTemplates(getPagination(searchValue), renderTemplatesList);
      }
    }
    setFirstTimeLoad(false);
  }, []);

  useEffect(() => {
    // if (!firstTimeLoad) clearAllSelection();
  }, [myTemplatesList, featuredTemplatesList, sharedTemplatesList]);

  useEffect(() => {
    if (searchValue !== '') setTemplatesLoaded((prev: ITemplateLoad) => ({ ...prev, [templateType]: false }));
  }, [searchValue]);

  useEffect(() => {
    if (searchValue !== '') {
      setSearchValue('');
      setIsSearched(false);
    }

    //To get newly added my templates
    getRespectiveTemplates();
    clearAllSelection();
  }, [templateType]);

  return (
    <Wrapper className={`wrapper-campaign-keyword ${isToggle ? 'open' : ''}`}>
      <Row gutter={26}>
        <Col className="gutter-row pb-2" span={12}>
          <h4 className="main-title">Templates</h4>
        </Col>
        <TemplatesHeader
          setTemplateType={setTemplateType}
          templateType={templateType}
          searchValue={searchValue}
          cleanSearchField={cleanSearchField}
          searchTemplates={searchTemplates}
          clearAllSelection={clearAllSelection}
        />
        <Col className="gutter-row" span={24}>
          <div className="Scroll-wrapper" id={firstTimeLoad === false ? 'templatesScroll' : ''}>
            {templateType === TEMPLATES_TYPE.FEATURED && (
              <InfiniteLoader
                dataLength={featuredTemplatesList?.length}
                next={() => getTemplates(getPagination(searchValue), renderTemplatesList)}
                hasMore={true}
                loader={<TemplatesPlaceholder loading={loading} />}
                scrollableTarget="templatesScroll"
              >
                <Row gutter={{ xs: 8, sm: 16, md: 20, lg: 24, xl: 42 }}>
                  {/* adding check for featured?.templates?.length > 0 so when it gets clear it will show loader instead of already present data */}
                  {featuredTemplatesList?.length > 0 && featured?.templates?.length > 0 && templatesSearchSuccess ? (
                    featuredTemplatesList.map((template: ITemplateItem, key: number) => {
                      return (
                        <Col
                          className="gutter-row"
                          span={6}
                          // xl={{ span: 6 }} lg={{ span: 12 }}
                        >
                          <TemplateCard
                            selectedTemplateId={selectedTemplateId}
                            template={template}
                            key={key}
                            selectTemplate={selectTemplate}
                            setShowPreview={showPreview}
                            clearAllSelection={clearAllSelection}
                          />
                        </Col>
                      );
                    })
                  ) : !loading ? (
                    <Col className="gutter-row" span={24} style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
                      {templatesSearchSuccess ? 'No template found.' : templatesSearchErrorMessage}
                    </Col>
                  ) : null}
                </Row>
              </InfiniteLoader>
            )}
            {templateType === TEMPLATES_TYPE.MY_TEMPLATES && (
              <InfiniteLoader
                dataLength={myTemplatesList?.length}
                next={() => getTemplates(getPagination(searchValue), renderTemplatesList)}
                hasMore={true}
                loader={<TemplatesPlaceholder loading={loading} />}
                scrollableTarget="templatesScroll"
              >
                <Row gutter={26}>
                  {/* adding check for my_templates?.templates?.length so when it gets clear it will show loader instead of already present data */}
                  {myTemplatesList?.length > 0 && my_templates?.templates?.length > 0 && templatesSearchSuccess ? (
                    myTemplatesList.map((template: ITemplateItem, key: number) => {
                      return (
                        <Col className="gutter-row" span={6}>
                          <TemplateCard
                            template={template}
                            key={key}
                            selectTemplate={selectTemplate}
                            setShowPreview={showPreview}
                            clearAllSelection={clearAllSelection}
                          />
                        </Col>
                      );
                    })
                  ) : !loading ? (
                    <Col className="gutter-row" span={24} style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
                      {templatesSearchSuccess ? 'No template found.' : templatesSearchErrorMessage}
                    </Col>
                  ) : null}
                </Row>
              </InfiniteLoader>
            )}
            {templateType === TEMPLATES_TYPE.SHARED && (
              <InfiniteLoader
                dataLength={sharedTemplatesList?.length}
                next={() => getTemplates(getPagination(searchValue), renderTemplatesList)}
                hasMore={true}
                loader={<TemplatesPlaceholder loading={loading} />}
                scrollableTarget="templatesScroll"
              >
                <Row gutter={26}>
                  {/* adding check for shared?.templates?.length so when it gets clear it will show loader instead of already present data */}
                  {sharedTemplatesList?.length > 0 && shared?.templates?.length > 0 && templatesSearchSuccess ? (
                    sharedTemplatesList.map((template: ITemplateItem, key: number) => {
                      return (
                        <Col className="gutter-row" span={6}>
                          <TemplateCard
                            template={template}
                            key={key}
                            selectTemplate={selectTemplate}
                            setShowPreview={showPreview}
                            clearAllSelection={clearAllSelection}
                          />
                        </Col>
                      );
                    })
                  ) : !loading ? (
                    <Col className="gutter-row" span={24} style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
                      {templatesSearchSuccess ? 'No template found.' : templatesSearchErrorMessage}
                    </Col>
                  ) : null}
                </Row>
              </InfiniteLoader>
            )}
            <div className={`footer-wrapper ${toggleFooter}`}>
              <ButtonRightIconGreen icon={DoneGreen} label="Done" classBtn="done-btn qa-done-two" />
            </div>
          </div>
        </Col>
      </Row>
      {/* Toggle preview popup */}
      {togglePreview && (
        <div className="preview-screen active">
          <div className="preview-label">Email Preview</div>
          <PreviewFull assetType={ASSET_TYPE.CUSTOM} templateId={templateIdPreview} />
          <span className="close-preview" onClick={() => setTogglePreview(false)}>
            <img src={Cross} />
          </span>
        </div>
      )}
    </Wrapper>
  );
};

export default TemplateAsider;

const Wrapper = styled.div`
  transition: 0.5s;
  box-sizing: border-box;
  height: 100vh;
  overflow-y: auto;
  width: 0px;
  background-color: #f7f7f7;
  position: relative;
  &.open {
    width: calc(100vw - 640px);
    /* min-width: 550px; */
    transition: 0.5s;
    overflow: hidden;
    padding: 62px 55px 29px 55px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 50px 40px 30px 40px;
      width: calc(100vw - 515px);
    }
  }
  .main-title {
    color: #424b50 !important;
    font-size: 22px;
    font-family: 'Roboto Slab', serif;
    font-weight: 500;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
  }
  .Scroll-wrapper {
    max-height: calc(100vh - 200px);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 14px;
    margin: 0 -14px;
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
    &.show-footer {
      max-height: calc(100vh - 270px);
      .footer-wrapper {
        display: flex;
      }
    }
    .footer-wrapper {
      border-top: 2px solid #eee;
      width: calc(100% + 50px);
      padding: 23px 40px;
      margin: 0 -25px;
      display: flex;
      justify-content: flex-end;
      position: absolute;
      bottom: -82px;
      left: 0;
      background: #fff;
      display: none;
      .done-btn {
        height: 30px;
        padding-left: 12px;
        &.disabled {
          opacity: 0.5;
          pointer-events: none;
        }
        span {
          &.label {
            font-size: 12px;
            font-weight: 500;
            font-family: 'Roboto', sans-serif;
          }
          &.icon {
            padding: 5px;
            img {
              height: 12px;
            }
          }
        }
      }
    }
  }
  .preview-screen {
    height: 100vh;
    background-color: #f9f8f6;
    z-index: -999;
    display: none;
    padding-right: 15px;
    transition: 0.5s;
    position: fixed;
    top: 0;
    left: 88px;
    width: calc(100% - 88px);
    padding-top: 25px;
    border-right: 1px solid #b5c3d4;
    overflow: auto;
    box-sizing: border-box;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: calc(100% - 63px);
      left: 63px;
    }
    &.active {
      z-index: 999;
      display: block;
    }
    .ant-tabs-nav {
      .ant-tabs-nav-list {
        transform: translate(-50%, 0px) !important;
        left: 50% !important;
        .ant-tabs-tab {
          margin-left: 0px;
          border-radius: 8px 0 0 8px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            border-radius: 6px 0 0 6px;
          }
          + .ant-tabs-tab {
            margin-left: 0px;
            border-radius: 0 8px 8px 0;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              border-radius: 0 6px 6px 0;
            }
          }
        }
      }
    }
    .preview-label {
      position: absolute;
      top: 20px;
      left: 25px;
      color: #424b50;
      font-family: 'Roboto Slab', serif;
      font-weight: 500;
      font-size: 32px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 24px;
        top: 25px;
      }
    }
    .close-preview {
      position: absolute;
      top: 30px;
      right: 20px;
      z-index: 9;
      cursor: pointer;
    }
  }
  // .preview-screen {
  //   height: 100vh;
  //   background-color: #f9f8f6;
  //   z-index: -999;
  //   display: none;
  //   padding-right: 15px;
  //   transition: 0.5s;
  //   position: fixed;
  //   top: 0;
  //   left: 88px;
  //   max-width: calc(100% - 635px);
  //   width: calc(100% - (100vw - 1145px));
  //   padding-top: 25px;
  //   border-right: 1px solid #b5c3d4;
  //   overflow: auto;
  //   &.active {
  //     z-index: 9;
  //     display: block;
  //   }
  //   scrollbar-width: thin;
  //   scrollbar-color: #001760 #efefef;
  //   &::-webkit-scrollbar {
  //     width: 5px;
  //     height: 5px;
  //     border-radius: 5px;
  //   }
  //   /* Track */
  //   &::-webkit-scrollbar-track {
  //     background: #fff;
  //     margin-top: 10px;
  //     margin-bottom: 15px;
  //   }
  //   /* Handle */
  //   &::-webkit-scrollbar-thumb {
  //     background: #001760;
  //   }
  //   /* Handle on hover */
  //   &::-webkit-scrollbar-thumb:hover {
  //     background: #555;
  //   }
  //   .close-preview {
  //     position: absolute;
  //     top: 30px;
  //     right: 20px;
  //     z-index: 9;
  //     cursor: pointer;
  //   }
  // }
`;
